/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Console_Nav_HomeInputs */
/** @typedef {{}} Console_Nav_InboxInputs */
/** @typedef {{}} Console_Nav_KnowledgeInputs */
/** @typedef {{}} Console_Nav_PlaygroundInputs */
/** @typedef {{}} Console_Nav_SettingsInputs */
/** @typedef {{}} Console_Store_ChannelInputs */
/** @typedef {{}} Console_Store_Open_In_ShopifyInputs */
/** @typedef {{}} Console_Theme_DarkInputs */
/** @typedef {{}} Console_Theme_LightInputs */
/** @typedef {{}} Console_Theme_SystemInputs */
/** @typedef {{}} Home_Empty_No_Conversations_BodyInputs */
/** @typedef {{}} Home_Empty_No_Conversations_HeadingInputs */
/** @typedef {{ store: NonNullable<unknown> }} Home_Empty_No_Conversations_NoteInputs */
/** @typedef {{}} Home_Empty_No_Knowledge_BodyInputs */
/** @typedef {{}} Home_Empty_No_Knowledge_HeadingInputs */
/** @typedef {{}} Home_Empty_Storefront_Not_Live_BodyInputs */
/** @typedef {{}} Home_Empty_Storefront_Not_Live_HeadingInputs */
/** @typedef {{}} Home_Metric_Ai_Resolution_HelpInputs */
/** @typedef {{}} Home_Metric_Ai_Resolution_LabelInputs */
/** @typedef {{ change: NonNullable<unknown> }} Home_Metric_Change_CountInputs */
/** @typedef {{ change: NonNullable<unknown> }} Home_Metric_Change_PointsInputs */
/** @typedef {{}} Home_Metric_Change_UnavailableInputs */
/** @typedef {{}} Home_Metric_Conversations_HelpInputs */
/** @typedef {{}} Home_Metric_Conversations_LabelInputs */
/** @typedef {{ metric: NonNullable<unknown> }} Home_Metric_Help_LabelInputs */
/** @typedef {{}} Home_Metric_Human_Backstop_HelpInputs */
/** @typedef {{}} Home_Metric_Human_Backstop_LabelInputs */
/** @typedef {{}} Home_Metric_Value_UnavailableInputs */
/** @typedef {{}} Home_Metrics_Failure_ForbiddenInputs */
/** @typedef {{}} Home_Metrics_Failure_NetworkInputs */
/** @typedef {{}} Home_Metrics_Failure_RejectedInputs */
/** @typedef {{}} Home_Metrics_Failure_SchemaInputs */
/** @typedef {{}} Home_Metrics_Failure_UnexpectedInputs */
/** @typedef {{}} Home_Metrics_LoadingInputs */
/** @typedef {{}} Home_Page_TitleInputs */
/** @typedef {{}} Home_Period_LabelInputs */
/** @typedef {{}} Home_Period_Last_30_DaysInputs */
/** @typedef {{}} Home_Period_Last_7_DaysInputs */
/** @typedef {{}} Home_Store_Connection_LoadingInputs */
/** @typedef {{}} Home_Trend_Chart_Label_DailyInputs */
/** @typedef {{}} Home_Trend_Chart_Label_WeeklyInputs */
/** @typedef {{}} Home_Trend_Series_Ai_ResolvedInputs */
/** @typedef {{}} Home_Trend_Series_ConversationsInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Home_Trend_Subtitle_DailyInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Home_Trend_Subtitle_WeeklyInputs */
/** @typedef {{}} Home_Trend_TitleInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Home_Trend_Tooltip_RangeInputs */
/** @typedef {{ time: NonNullable<unknown> }} Home_Updated_AtInputs */
/** @typedef {{}} Inbox_Conversation_HandoffInputs */
/** @typedef {{ count: NonNullable<unknown> }} Inbox_Conversation_Message_CountInputs */
/** @typedef {{}} Inbox_Conversation_Message_Count_OneInputs */
/** @typedef {{}} Inbox_Conversation_Request_SentInputs */
/** @typedef {{}} Inbox_Conversations_Failure_ForbiddenInputs */
/** @typedef {{}} Inbox_Conversations_Failure_NetworkInputs */
/** @typedef {{}} Inbox_Conversations_Failure_RejectedInputs */
/** @typedef {{}} Inbox_Conversations_Failure_SchemaInputs */
/** @typedef {{}} Inbox_Conversations_Failure_UnexpectedInputs */
/** @typedef {{}} Inbox_List_Empty_BodyInputs */
/** @typedef {{}} Inbox_List_Empty_HeadingInputs */
/** @typedef {{}} Inbox_List_HeadingInputs */
/** @typedef {{}} Inbox_List_Load_MoreInputs */
/** @typedef {{}} Inbox_List_LoadingInputs */
/** @typedef {{}} Inbox_List_Loading_MoreInputs */
/** @typedef {{}} Inbox_Page_TitleInputs */
/** @typedef {{}} Inbox_Replay_BackInputs */
/** @typedef {{}} Inbox_Replay_Empty_BodyInputs */
/** @typedef {{}} Inbox_Replay_Empty_HeadingInputs */
/** @typedef {{}} Inbox_Replay_Feedback_NegativeInputs */
/** @typedef {{}} Inbox_Replay_Feedback_PositiveInputs */
/** @typedef {{}} Inbox_Replay_LoadingInputs */
/** @typedef {{ started: NonNullable<unknown>, last: NonNullable<unknown> }} Inbox_Replay_MetaInputs */
/** @typedef {{}} Inbox_Replay_Read_OnlyInputs */
/** @typedef {{}} Inbox_Replay_Transcript_LabelInputs */
/** @typedef {{}} Knowledge_Category_AllInputs */
/** @typedef {{}} Knowledge_Category_EmptyInputs */
/** @typedef {{}} Knowledge_Category_LabelInputs */
/** @typedef {{}} Knowledge_Category_NoneInputs */
/** @typedef {{}} Knowledge_Category_SearchInputs */
/** @typedef {{}} Knowledge_Column_CategoryInputs */
/** @typedef {{}} Knowledge_Column_InventoryInputs */
/** @typedef {{}} Knowledge_Column_PriceInputs */
/** @typedef {{}} Knowledge_Column_ProductInputs */
/** @typedef {{}} Knowledge_Column_VariantsInputs */
/** @typedef {{}} Knowledge_Empty_Products_BodyInputs */
/** @typedef {{}} Knowledge_Empty_Products_HeadingInputs */
/** @typedef {{}} Knowledge_Empty_Questions_BodyInputs */
/** @typedef {{}} Knowledge_Empty_Questions_HeadingInputs */
/** @typedef {{}} Knowledge_Empty_Search_BodyInputs */
/** @typedef {{}} Knowledge_Empty_Search_HeadingInputs */
/** @typedef {{}} Knowledge_Failure_ForbiddenInputs */
/** @typedef {{}} Knowledge_Failure_NetworkInputs */
/** @typedef {{}} Knowledge_Failure_RejectedInputs */
/** @typedef {{}} Knowledge_Failure_SchemaInputs */
/** @typedef {{}} Knowledge_Failure_UnexpectedInputs */
/** @typedef {{}} Knowledge_Inventory_UntrackedInputs */
/** @typedef {{}} Knowledge_Load_MoreInputs */
/** @typedef {{}} Knowledge_LoadingInputs */
/** @typedef {{}} Knowledge_Loading_MoreInputs */
/** @typedef {{}} Knowledge_Page_TitleInputs */
/** @typedef {{ category: NonNullable<unknown>, price: NonNullable<unknown>, inventory: NonNullable<unknown>, variants: NonNullable<unknown> }} Knowledge_Product_MetaInputs */
/** @typedef {{}} Knowledge_Search_LabelInputs */
/** @typedef {{}} Knowledge_Search_PlaceholderInputs */
/** @typedef {{}} Knowledge_Tab_ProductsInputs */
/** @typedef {{}} Knowledge_Tab_QuestionsInputs */
/** @typedef {{}} Knowledge_Tabs_LabelInputs */
/** @typedef {{}} Knowledge_Test_In_PlaygroundInputs */
/** @typedef {{}} Playground_Failure_ForbiddenInputs */
/** @typedef {{}} Playground_Failure_NetworkInputs */
/** @typedef {{}} Playground_Failure_RejectedInputs */
/** @typedef {{}} Playground_Failure_SchemaInputs */
/** @typedef {{}} Playground_Failure_UnexpectedInputs */
/** @typedef {{}} Playground_Live_ConfigInputs */
/** @typedef {{}} Playground_Page_TitleInputs */
/** @typedef {{}} Playground_Real_Business_NoticeInputs */
/** @typedef {{}} Playground_ResetInputs */
/** @typedef {{}} Settings_Agent_CopyInputs */
/** @typedef {{}} Settings_Agent_Name_LabelInputs */
/** @typedef {{}} Settings_Character_HintInputs */
/** @typedef {{}} Settings_Character_LabelInputs */
/** @typedef {{}} Settings_Character_SolidInputs */
/** @typedef {{}} Settings_Character_WatercolorInputs */
/** @typedef {{}} Settings_Color_Picker_LabelInputs */
/** @typedef {{}} Settings_Color_Shape_HeadingInputs */
/** @typedef {{}} Settings_Copy_Button_CopyInputs */
/** @typedef {{}} Settings_Copy_Button_TitleInputs */
/** @typedef {{}} Settings_Direction_EditorialInputs */
/** @typedef {{}} Settings_Direction_HairlineInputs */
/** @typedef {{}} Settings_Direction_HintInputs */
/** @typedef {{}} Settings_Direction_LabelInputs */
/** @typedef {{}} Settings_Disable_CancelInputs */
/** @typedef {{}} Settings_Disable_ConfirmInputs */
/** @typedef {{}} Settings_Disable_DescriptionInputs */
/** @typedef {{}} Settings_Disable_TitleInputs */
/** @typedef {{}} Settings_DiscardInputs */
/** @typedef {{}} Settings_Error_Agent_NameInputs */
/** @typedef {{ tab: NonNullable<unknown> }} Settings_Error_Go_To_TabInputs */
/** @typedef {{}} Settings_Error_Proactive_RulesInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Error_Rule_PromptInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Error_Rule_QuestionInputs */
/** @typedef {{}} Settings_Error_Rule_SelectorInputs */
/** @typedef {{}} Settings_Error_Rule_WaitInputs */
/** @typedef {{}} Settings_Error_Suggested_QuestionInputs */
/** @typedef {{}} Settings_Error_Suggested_Question_DuplicateInputs */
/** @typedef {{}} Settings_Error_Support_EmailInputs */
/** @typedef {{}} Settings_Error_Tab_FieldsInputs */
/** @typedef {{}} Settings_Error_Theme_ColorInputs */
/** @typedef {{}} Settings_Error_Welcome_MessageInputs */
/** @typedef {{}} Settings_Failure_ForbiddenInputs */
/** @typedef {{}} Settings_Failure_NetworkInputs */
/** @typedef {{}} Settings_Failure_RejectedInputs */
/** @typedef {{}} Settings_Failure_SchemaInputs */
/** @typedef {{}} Settings_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Font_HintInputs */
/** @typedef {{}} Settings_Font_LabelInputs */
/** @typedef {{}} Settings_Font_SansInputs */
/** @typedef {{}} Settings_Font_SerifInputs */
/** @typedef {{}} Settings_Font_Size_LabelInputs */
/** @typedef {{}} Settings_Font_Size_LargeInputs */
/** @typedef {{}} Settings_Font_Size_SmallInputs */
/** @typedef {{}} Settings_Font_Size_StandardInputs */
/** @typedef {{}} Settings_Font_ThemeInputs */
/** @typedef {{}} Settings_Glass_HintInputs */
/** @typedef {{}} Settings_Glass_LabelInputs */
/** @typedef {{}} Settings_Glass_OffInputs */
/** @typedef {{}} Settings_Glass_OnInputs */
/** @typedef {{}} Settings_Handoff_CopyInputs */
/** @typedef {{}} Settings_Handoff_HeadingInputs */
/** @typedef {{}} Settings_Hex_LabelInputs */
/** @typedef {{}} Settings_Launcher_Drag_CopyInputs */
/** @typedef {{}} Settings_Launcher_Drag_TitleInputs */
/** @typedef {{}} Settings_Leave_CancelInputs */
/** @typedef {{}} Settings_Leave_ConfirmInputs */
/** @typedef {{}} Settings_Leave_DescriptionInputs */
/** @typedef {{}} Settings_Leave_TitleInputs */
/** @typedef {{}} Settings_LoadingInputs */
/** @typedef {{}} Settings_Logo_AltInputs */
/** @typedef {{}} Settings_Logo_Failure_Too_LargeInputs */
/** @typedef {{}} Settings_Logo_Failure_TypeInputs */
/** @typedef {{}} Settings_Logo_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Logo_File_LabelInputs */
/** @typedef {{}} Settings_Logo_HintInputs */
/** @typedef {{}} Settings_Logo_LabelInputs */
/** @typedef {{}} Settings_Logo_RemoveInputs */
/** @typedef {{}} Settings_Logo_ReplaceInputs */
/** @typedef {{}} Settings_Logo_UploadInputs */
/** @typedef {{}} Settings_Messages_HeadingInputs */
/** @typedef {{}} Settings_Page_TitleInputs */
/** @typedef {{}} Settings_Position_Bottom_LeftInputs */
/** @typedef {{}} Settings_Position_Bottom_RightInputs */
/** @typedef {{}} Settings_Position_LabelInputs */
/** @typedef {{}} Settings_Preview_ConversationInputs */
/** @typedef {{}} Settings_Preview_DesktopInputs */
/** @typedef {{}} Settings_Preview_Device_LabelInputs */
/** @typedef {{}} Settings_Preview_HeadingInputs */
/** @typedef {{}} Settings_Preview_HiddenInputs */
/** @typedef {{}} Settings_Preview_LauncherInputs */
/** @typedef {{}} Settings_Preview_MobileInputs */
/** @typedef {{}} Settings_Preview_ProactiveInputs */
/** @typedef {{}} Settings_Preview_Store_NameInputs */
/** @typedef {{}} Settings_Preview_View_LabelInputs */
/** @typedef {{}} Settings_Proactive_AddInputs */
/** @typedef {{}} Settings_Proactive_CopyInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_DeleteInputs */
/** @typedef {{}} Settings_Proactive_Delete_CancelInputs */
/** @typedef {{}} Settings_Proactive_Delete_ConfirmInputs */
/** @typedef {{}} Settings_Proactive_Delete_DescriptionInputs */
/** @typedef {{}} Settings_Proactive_Delete_TitleInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_EditInputs */
/** @typedef {{}} Settings_Proactive_Empty_BodyInputs */
/** @typedef {{}} Settings_Proactive_Empty_HeadingInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_EnableInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Settings_Proactive_Field_CountInputs */
/** @typedef {{}} Settings_Proactive_HeadingInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Proactive_Insert_PlaceholderInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_Move_DownInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_Move_UpInputs */
/** @typedef {{}} Settings_Proactive_No_PromptInputs */
/** @typedef {{}} Settings_Proactive_PickInputs */
/** @typedef {{}} Settings_Proactive_Pick_AgainInputs */
/** @typedef {{}} Settings_Proactive_Pick_AppliedInputs */
/** @typedef {{}} Settings_Proactive_Pick_BlockedInputs */
/** @typedef {{}} Settings_Proactive_Pick_CancelInputs */
/** @typedef {{}} Settings_Proactive_Pick_Cancel_FailedInputs */
/** @typedef {{}} Settings_Proactive_Pick_ConflictInputs */
/** @typedef {{}} Settings_Proactive_Pick_Conflict_BlockedInputs */
/** @typedef {{}} Settings_Proactive_Pick_DismissInputs */
/** @typedef {{}} Settings_Proactive_Pick_Embed_HintInputs */
/** @typedef {{}} Settings_Proactive_Pick_Failure_PopupInputs */
/** @typedef {{}} Settings_Proactive_Pick_Failure_RejectedInputs */
/** @typedef {{}} Settings_Proactive_Pick_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Proactive_Pick_GoneInputs */
/** @typedef {{}} Settings_Proactive_Pick_KeepInputs */
/** @typedef {{}} Settings_Proactive_Pick_Save_FirstInputs */
/** @typedef {{}} Settings_Proactive_Pick_UseInputs */
/** @typedef {{}} Settings_Proactive_PickingInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Proactive_Prompt_HintInputs */
/** @typedef {{}} Settings_Proactive_Prompt_LabelInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Proactive_Question_HintInputs */
/** @typedef {{}} Settings_Proactive_Question_LabelInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_RuleInputs */
/** @typedef {{}} Settings_Proactive_Selector_HintInputs */
/** @typedef {{}} Settings_Proactive_Selector_LabelInputs */
/** @typedef {{}} Settings_Proactive_Target_RequiredInputs */
/** @typedef {{}} Settings_Proactive_Trigger_ElementInputs */
/** @typedef {{}} Settings_Proactive_Trigger_Element_HintInputs */
/** @typedef {{}} Settings_Proactive_Trigger_EntryInputs */
/** @typedef {{}} Settings_Proactive_Trigger_Entry_HintInputs */
/** @typedef {{}} Settings_Proactive_Trigger_IdleInputs */
/** @typedef {{}} Settings_Proactive_Trigger_Idle_HintInputs */
/** @typedef {{}} Settings_Proactive_Trigger_LabelInputs */
/** @typedef {{}} Settings_Proactive_Wait_LabelInputs */
/** @typedef {{}} Settings_Proactive_Wait_SuffixInputs */
/** @typedef {{}} Settings_Prompt_Style_BodyInputs */
/** @typedef {{}} Settings_Prompt_Style_BubbleInputs */
/** @typedef {{}} Settings_Prompt_Style_HintInputs */
/** @typedef {{}} Settings_Prompt_Style_LabelInputs */
/** @typedef {{}} Settings_Radius_LabelInputs */
/** @typedef {{}} Settings_Radius_PresetInputs */
/** @typedef {{}} Settings_Radius_RoundInputs */
/** @typedef {{}} Settings_Radius_RoundedInputs */
/** @typedef {{}} Settings_Radius_SquareInputs */
/** @typedef {{}} Settings_SaveInputs */
/** @typedef {{}} Settings_Save_FailedInputs */
/** @typedef {{}} Settings_Save_Failure_RejectedInputs */
/** @typedef {{}} Settings_Save_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Save_HintInputs */
/** @typedef {{}} Settings_Save_SuccessInputs */
/** @typedef {{}} Settings_SavedInputs */
/** @typedef {{}} Settings_SavingInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_LabelInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_Move_DownInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_Move_UpInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_RemoveInputs */
/** @typedef {{}} Settings_Suggested_Questions_AddInputs */
/** @typedef {{}} Settings_Suggested_Questions_HintInputs */
/** @typedef {{}} Settings_Suggested_Questions_LabelInputs */
/** @typedef {{}} Settings_Suggested_Questions_LimitInputs */
/** @typedef {{}} Settings_Support_Email_HintInputs */
/** @typedef {{}} Settings_Support_Email_LabelInputs */
/** @typedef {{}} Settings_Support_Failed_BodyInputs */
/** @typedef {{}} Settings_Support_Failed_TitleInputs */
/** @typedef {{}} Settings_Support_Hint_UnsavedInputs */
/** @typedef {{}} Settings_Support_Hint_VerifiedInputs */
/** @typedef {{}} Settings_Support_Mark_UnsavedInputs */
/** @typedef {{}} Settings_Support_Mark_UnverifiedInputs */
/** @typedef {{}} Settings_Support_Mark_VerifiedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Settings_Support_Pending_BodyInputs */
/** @typedef {{}} Settings_Support_Pending_TitleInputs */
/** @typedef {{}} Settings_Support_ResendInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Settings_Support_Resend_WaitInputs */
/** @typedef {{}} Settings_Support_Resent_BodyInputs */
/** @typedef {{}} Settings_Support_Resent_TitleInputs */
/** @typedef {{}} Settings_Support_SendInputs */
/** @typedef {{}} Settings_Support_SendingInputs */
/** @typedef {{ time: NonNullable<unknown> }} Settings_Support_Sent_AtInputs */
/** @typedef {{}} Settings_Support_Try_AgainInputs */
/** @typedef {{}} Settings_Support_Unavailable_BodyInputs */
/** @typedef {{}} Settings_Support_Unavailable_TitleInputs */
/** @typedef {{ email: NonNullable<unknown> }} Settings_Support_Unsent_BodyInputs */
/** @typedef {{}} Settings_Support_Unsent_TitleInputs */
/** @typedef {{}} Settings_Surface_DarkInputs */
/** @typedef {{}} Settings_Surface_HintInputs */
/** @typedef {{}} Settings_Surface_LabelInputs */
/** @typedef {{}} Settings_Surface_LightInputs */
/** @typedef {{}} Settings_Swatch_CustomInputs */
/** @typedef {{}} Settings_Swatch_DefaultInputs */
/** @typedef {{}} Settings_Swatch_ForestInputs */
/** @typedef {{}} Settings_Swatch_IndigoInputs */
/** @typedef {{}} Settings_Swatch_LuxuryInputs */
/** @typedef {{}} Settings_Swatch_MinimalInputs */
/** @typedef {{}} Settings_Swatch_PlayfulInputs */
/** @typedef {{}} Settings_Swatch_RoseInputs */
/** @typedef {{}} Settings_Swatch_WarmInputs */
/** @typedef {{}} Settings_Tab_AppearanceInputs */
/** @typedef {{}} Settings_Tab_Chat_WindowInputs */
/** @typedef {{}} Settings_Tab_HandoffInputs */
/** @typedef {{}} Settings_Tab_LauncherInputs */
/** @typedef {{}} Settings_Tab_Needs_AttentionInputs */
/** @typedef {{}} Settings_Tab_ProactiveInputs */
/** @typedef {{}} Settings_Tabs_LabelInputs */
/** @typedef {{}} Settings_Text_HeadingInputs */
/** @typedef {{}} Settings_Theme_Color_HintInputs */
/** @typedef {{}} Settings_Theme_Color_LabelInputs */
/** @typedef {{}} Settings_Theme_EditorInputs */
/** @typedef {{}} Settings_Title_Bar_HeadingInputs */
/** @typedef {{}} Settings_Visibility_PendingInputs */
/** @typedef {{}} Settings_Visibility_TitleInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Settings_Welcome_CountInputs */
/** @typedef {{}} Settings_Welcome_HeadingInputs */
/** @typedef {{}} Settings_Welcome_HintInputs */
/** @typedef {{}} Settings_Welcome_LabelInputs */
/** @typedef {{}} Store_Connection_Error_HeadingInputs */
/** @typedef {{}} Store_Connection_Expired_HeadingInputs */
/** @typedef {{}} Store_Connection_Failure_ForbiddenInputs */
/** @typedef {{}} Store_Connection_Failure_NetworkInputs */
/** @typedef {{}} Store_Connection_Failure_RejectedInputs */
/** @typedef {{}} Store_Connection_Failure_SchemaInputs */
/** @typedef {{}} Store_Connection_Failure_UnexpectedInputs */
/** @typedef {{}} Store_Connection_Preparing_BodyInputs */
/** @typedef {{}} Store_Connection_Preparing_HeadingInputs */
/** @typedef {{}} Store_Connection_RefreshInputs */
/** @typedef {{}} Store_Entry_BodyInputs */
/** @typedef {{}} Store_Entry_HeadingInputs */
import * as __en from "./en.js"
/**
* | output |
* | --- |
* | "Home" |
*
* @param {Console_Nav_HomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_nav_home = /** @type {((inputs?: Console_Nav_HomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Nav_HomeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_nav_home(inputs)
});
/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Console_Nav_InboxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_nav_inbox = /** @type {((inputs?: Console_Nav_InboxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Nav_InboxInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_nav_inbox(inputs)
});
/**
* | output |
* | --- |
* | "Knowledge" |
*
* @param {Console_Nav_KnowledgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_nav_knowledge = /** @type {((inputs?: Console_Nav_KnowledgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Nav_KnowledgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_nav_knowledge(inputs)
});
/**
* | output |
* | --- |
* | "Playground" |
*
* @param {Console_Nav_PlaygroundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_nav_playground = /** @type {((inputs?: Console_Nav_PlaygroundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Nav_PlaygroundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_nav_playground(inputs)
});
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Console_Nav_SettingsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_nav_settings = /** @type {((inputs?: Console_Nav_SettingsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Nav_SettingsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_nav_settings(inputs)
});
/**
* | output |
* | --- |
* | "Shopify" |
*
* @param {Console_Store_ChannelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_store_channel = /** @type {((inputs?: Console_Store_ChannelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Store_ChannelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_store_channel(inputs)
});
/**
* | output |
* | --- |
* | "Open in Shopify admin" |
*
* @param {Console_Store_Open_In_ShopifyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_store_open_in_shopify = /** @type {((inputs?: Console_Store_Open_In_ShopifyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Store_Open_In_ShopifyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_store_open_in_shopify(inputs)
});
/**
* | output |
* | --- |
* | "Dark mode" |
*
* @param {Console_Theme_DarkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_theme_dark = /** @type {((inputs?: Console_Theme_DarkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Theme_DarkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_theme_dark(inputs)
});
/**
* | output |
* | --- |
* | "Light mode" |
*
* @param {Console_Theme_LightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_theme_light = /** @type {((inputs?: Console_Theme_LightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Theme_LightInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_theme_light(inputs)
});
/**
* | output |
* | --- |
* | "System" |
*
* @param {Console_Theme_SystemInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const console_theme_system = /** @type {((inputs?: Console_Theme_SystemInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Theme_SystemInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.console_theme_system(inputs)
});
/**
* | output |
* | --- |
* | "Metrics appear here as soon as a shopper sends the first message through the storefront chat widget." |
*
* @param {Home_Empty_No_Conversations_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_no_conversations_body = /** @type {((inputs?: Home_Empty_No_Conversations_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_No_Conversations_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_no_conversations_body(inputs)
});
/**
* | output |
* | --- |
* | "Your AI is ready — waiting for the first conversation" |
*
* @param {Home_Empty_No_Conversations_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_no_conversations_heading = /** @type {((inputs?: Home_Empty_No_Conversations_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_No_Conversations_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_no_conversations_heading(inputs)
});
/**
* | output |
* | --- |
* | "Nothing to set up — the widget is already live on {store}" |
*
* @param {Home_Empty_No_Conversations_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_no_conversations_note = /** @type {((inputs: Home_Empty_No_Conversations_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_No_Conversations_NoteInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_no_conversations_note(inputs)
});
/**
* | output |
* | --- |
* | "Products and policies are still syncing. Metrics start once the AI has something to answer from." |
*
* @param {Home_Empty_No_Knowledge_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_no_knowledge_body = /** @type {((inputs?: Home_Empty_No_Knowledge_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_No_Knowledge_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_no_knowledge_body(inputs)
});
/**
* | output |
* | --- |
* | "Still preparing your store knowledge" |
*
* @param {Home_Empty_No_Knowledge_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_no_knowledge_heading = /** @type {((inputs?: Home_Empty_No_Knowledge_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_No_Knowledge_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_no_knowledge_heading(inputs)
});
/**
* | output |
* | --- |
* | "Turn the app embed on in your theme so shoppers can start conversations." |
*
* @param {Home_Empty_Storefront_Not_Live_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_storefront_not_live_body = /** @type {((inputs?: Home_Empty_Storefront_Not_Live_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_Storefront_Not_Live_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_storefront_not_live_body(inputs)
});
/**
* | output |
* | --- |
* | "The widget is not live on your storefront yet" |
*
* @param {Home_Empty_Storefront_Not_Live_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty_storefront_not_live_heading = /** @type {((inputs?: Home_Empty_Storefront_Not_Live_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Empty_Storefront_Not_Live_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_empty_storefront_not_live_heading(inputs)
});
/**
* | output |
* | --- |
* | "Conversations completed by AI without human support." |
*
* @param {Home_Metric_Ai_Resolution_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_ai_resolution_help = /** @type {((inputs?: Home_Metric_Ai_Resolution_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Ai_Resolution_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_ai_resolution_help(inputs)
});
/**
* | output |
* | --- |
* | "AI Resolution Rate" |
*
* @param {Home_Metric_Ai_Resolution_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_ai_resolution_label = /** @type {((inputs?: Home_Metric_Ai_Resolution_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Ai_Resolution_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_ai_resolution_label(inputs)
});
/**
* | output |
* | --- |
* | "{change} vs prior period" |
*
* @param {Home_Metric_Change_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_change_count = /** @type {((inputs: Home_Metric_Change_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Change_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_change_count(inputs)
});
/**
* | output |
* | --- |
* | "{change} pt vs prior period" |
*
* @param {Home_Metric_Change_PointsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_change_points = /** @type {((inputs: Home_Metric_Change_PointsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Change_PointsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_change_points(inputs)
});
/**
* | output |
* | --- |
* | "No prior period to compare" |
*
* @param {Home_Metric_Change_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_change_unavailable = /** @type {((inputs?: Home_Metric_Change_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Change_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_change_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Valid storefront conversations; Playground tests excluded." |
*
* @param {Home_Metric_Conversations_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_conversations_help = /** @type {((inputs?: Home_Metric_Conversations_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Conversations_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_conversations_help(inputs)
});
/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Home_Metric_Conversations_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_conversations_label = /** @type {((inputs?: Home_Metric_Conversations_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Conversations_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_conversations_label(inputs)
});
/**
* | output |
* | --- |
* | "About {metric}" |
*
* @param {Home_Metric_Help_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_help_label = /** @type {((inputs: Home_Metric_Help_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Help_LabelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_help_label(inputs)
});
/**
* | output |
* | --- |
* | "Conversations requiring human support." |
*
* @param {Home_Metric_Human_Backstop_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_human_backstop_help = /** @type {((inputs?: Home_Metric_Human_Backstop_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Human_Backstop_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_human_backstop_help(inputs)
});
/**
* | output |
* | --- |
* | "Human backstop" |
*
* @param {Home_Metric_Human_Backstop_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_human_backstop_label = /** @type {((inputs?: Home_Metric_Human_Backstop_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Human_Backstop_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_human_backstop_label(inputs)
});
/**
* | output |
* | --- |
* | "—" |
*
* @param {Home_Metric_Value_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metric_value_unavailable = /** @type {((inputs?: Home_Metric_Value_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metric_Value_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metric_value_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Your session expired. Reopen the admin from Shopify." |
*
* @param {Home_Metrics_Failure_ForbiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metrics_failure_forbidden = /** @type {((inputs?: Home_Metrics_Failure_ForbiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metrics_Failure_ForbiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metrics_failure_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach GoNovus. Check your connection and try again." |
*
* @param {Home_Metrics_Failure_NetworkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metrics_failure_network = /** @type {((inputs?: Home_Metrics_Failure_NetworkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metrics_Failure_NetworkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metrics_failure_network(inputs)
});
/**
* | output |
* | --- |
* | "Metrics are unavailable right now." |
*
* @param {Home_Metrics_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metrics_failure_rejected = /** @type {((inputs?: Home_Metrics_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metrics_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metrics_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Metrics came back in an unexpected shape." |
*
* @param {Home_Metrics_Failure_SchemaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metrics_failure_schema = /** @type {((inputs?: Home_Metrics_Failure_SchemaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metrics_Failure_SchemaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metrics_failure_schema(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong loading metrics." |
*
* @param {Home_Metrics_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metrics_failure_unexpected = /** @type {((inputs?: Home_Metrics_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metrics_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metrics_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "Loading metrics" |
*
* @param {Home_Metrics_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_metrics_loading = /** @type {((inputs?: Home_Metrics_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Metrics_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_metrics_loading(inputs)
});
/**
* | output |
* | --- |
* | "Home" |
*
* @param {Home_Page_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_page_title = /** @type {((inputs?: Home_Page_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Page_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_page_title(inputs)
});
/**
* | output |
* | --- |
* | "Reporting period" |
*
* @param {Home_Period_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_period_label = /** @type {((inputs?: Home_Period_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Period_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_period_label(inputs)
});
/**
* | output |
* | --- |
* | "Last 30 days" |
*
* @param {Home_Period_Last_30_DaysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_period_last_30_days = /** @type {((inputs?: Home_Period_Last_30_DaysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Period_Last_30_DaysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_period_last_30_days(inputs)
});
/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Home_Period_Last_7_DaysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_period_last_7_days = /** @type {((inputs?: Home_Period_Last_7_DaysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Period_Last_7_DaysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_period_last_7_days(inputs)
});
/**
* | output |
* | --- |
* | "Loading store details" |
*
* @param {Home_Store_Connection_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_store_connection_loading = /** @type {((inputs?: Home_Store_Connection_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Store_Connection_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_store_connection_loading(inputs)
});
/**
* | output |
* | --- |
* | "Daily conversations and AI resolved conversations" |
*
* @param {Home_Trend_Chart_Label_DailyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_chart_label_daily = /** @type {((inputs?: Home_Trend_Chart_Label_DailyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Chart_Label_DailyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_chart_label_daily(inputs)
});
/**
* | output |
* | --- |
* | "Weekly totals of conversations and AI resolved conversations" |
*
* @param {Home_Trend_Chart_Label_WeeklyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_chart_label_weekly = /** @type {((inputs?: Home_Trend_Chart_Label_WeeklyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Chart_Label_WeeklyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_chart_label_weekly(inputs)
});
/**
* | output |
* | --- |
* | "AI resolved" |
*
* @param {Home_Trend_Series_Ai_ResolvedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_series_ai_resolved = /** @type {((inputs?: Home_Trend_Series_Ai_ResolvedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Series_Ai_ResolvedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_series_ai_resolved(inputs)
});
/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Home_Trend_Series_ConversationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_series_conversations = /** @type {((inputs?: Home_Trend_Series_ConversationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Series_ConversationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_series_conversations(inputs)
});
/**
* | output |
* | --- |
* | "Daily · {start} – {end}" |
*
* @param {Home_Trend_Subtitle_DailyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_subtitle_daily = /** @type {((inputs: Home_Trend_Subtitle_DailyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Subtitle_DailyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_subtitle_daily(inputs)
});
/**
* | output |
* | --- |
* | "Weekly totals · {start} – {end}" |
*
* @param {Home_Trend_Subtitle_WeeklyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_subtitle_weekly = /** @type {((inputs: Home_Trend_Subtitle_WeeklyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Subtitle_WeeklyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_subtitle_weekly(inputs)
});
/**
* | output |
* | --- |
* | "Conversations & AI resolution" |
*
* @param {Home_Trend_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_title = /** @type {((inputs?: Home_Trend_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_title(inputs)
});
/**
* | output |
* | --- |
* | "{start} – {end}" |
*
* @param {Home_Trend_Tooltip_RangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_trend_tooltip_range = /** @type {((inputs: Home_Trend_Tooltip_RangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trend_Tooltip_RangeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_trend_tooltip_range(inputs)
});
/**
* | output |
* | --- |
* | "Updated {time}" |
*
* @param {Home_Updated_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_updated_at = /** @type {((inputs: Home_Updated_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Updated_AtInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.home_updated_at(inputs)
});
/**
* | output |
* | --- |
* | "Handed off" |
*
* @param {Inbox_Conversation_HandoffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversation_handoff = /** @type {((inputs?: Inbox_Conversation_HandoffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversation_HandoffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversation_handoff(inputs)
});
/**
* | output |
* | --- |
* | "{count} messages" |
*
* @param {Inbox_Conversation_Message_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversation_message_count = /** @type {((inputs: Inbox_Conversation_Message_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversation_Message_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversation_message_count(inputs)
});
/**
* | output |
* | --- |
* | "1 message" |
*
* @param {Inbox_Conversation_Message_Count_OneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversation_message_count_one = /** @type {((inputs?: Inbox_Conversation_Message_Count_OneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversation_Message_Count_OneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversation_message_count_one(inputs)
});
/**
* | output |
* | --- |
* | "Request sent" |
*
* @param {Inbox_Conversation_Request_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversation_request_sent = /** @type {((inputs?: Inbox_Conversation_Request_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversation_Request_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversation_request_sent(inputs)
});
/**
* | output |
* | --- |
* | "Your session expired. Reopen the admin from Shopify." |
*
* @param {Inbox_Conversations_Failure_ForbiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversations_failure_forbidden = /** @type {((inputs?: Inbox_Conversations_Failure_ForbiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversations_Failure_ForbiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversations_failure_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach GoNovus. Check your connection and try again." |
*
* @param {Inbox_Conversations_Failure_NetworkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversations_failure_network = /** @type {((inputs?: Inbox_Conversations_Failure_NetworkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversations_Failure_NetworkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversations_failure_network(inputs)
});
/**
* | output |
* | --- |
* | "Conversations are unavailable right now." |
*
* @param {Inbox_Conversations_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversations_failure_rejected = /** @type {((inputs?: Inbox_Conversations_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversations_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversations_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Conversations came back in an unexpected shape." |
*
* @param {Inbox_Conversations_Failure_SchemaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversations_failure_schema = /** @type {((inputs?: Inbox_Conversations_Failure_SchemaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversations_Failure_SchemaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversations_failure_schema(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong loading conversations." |
*
* @param {Inbox_Conversations_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_conversations_failure_unexpected = /** @type {((inputs?: Inbox_Conversations_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Conversations_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_conversations_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "Conversations appear here once shoppers start chatting." |
*
* @param {Inbox_List_Empty_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_list_empty_body = /** @type {((inputs?: Inbox_List_Empty_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_List_Empty_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_list_empty_body(inputs)
});
/**
* | output |
* | --- |
* | "No conversations yet" |
*
* @param {Inbox_List_Empty_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_list_empty_heading = /** @type {((inputs?: Inbox_List_Empty_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_List_Empty_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_list_empty_heading(inputs)
});
/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Inbox_List_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_list_heading = /** @type {((inputs?: Inbox_List_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_List_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_list_heading(inputs)
});
/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Inbox_List_Load_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_list_load_more = /** @type {((inputs?: Inbox_List_Load_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_List_Load_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_list_load_more(inputs)
});
/**
* | output |
* | --- |
* | "Loading conversations" |
*
* @param {Inbox_List_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_list_loading = /** @type {((inputs?: Inbox_List_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_List_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_list_loading(inputs)
});
/**
* | output |
* | --- |
* | "Loading more conversations" |
*
* @param {Inbox_List_Loading_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_list_loading_more = /** @type {((inputs?: Inbox_List_Loading_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_List_Loading_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_list_loading_more(inputs)
});
/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Inbox_Page_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_page_title = /** @type {((inputs?: Inbox_Page_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Page_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_page_title(inputs)
});
/**
* | output |
* | --- |
* | "All conversations" |
*
* @param {Inbox_Replay_BackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_back = /** @type {((inputs?: Inbox_Replay_BackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_BackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_back(inputs)
});
/**
* | output |
* | --- |
* | "Pick a conversation from the list to replay it message by message." |
*
* @param {Inbox_Replay_Empty_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_empty_body = /** @type {((inputs?: Inbox_Replay_Empty_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_Empty_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_empty_body(inputs)
});
/**
* | output |
* | --- |
* | "Select a conversation" |
*
* @param {Inbox_Replay_Empty_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_empty_heading = /** @type {((inputs?: Inbox_Replay_Empty_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_Empty_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_empty_heading(inputs)
});
/**
* | output |
* | --- |
* | "Marked not helpful" |
*
* @param {Inbox_Replay_Feedback_NegativeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_feedback_negative = /** @type {((inputs?: Inbox_Replay_Feedback_NegativeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_Feedback_NegativeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_feedback_negative(inputs)
});
/**
* | output |
* | --- |
* | "Marked helpful" |
*
* @param {Inbox_Replay_Feedback_PositiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_feedback_positive = /** @type {((inputs?: Inbox_Replay_Feedback_PositiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_Feedback_PositiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_feedback_positive(inputs)
});
/**
* | output |
* | --- |
* | "Loading the conversation" |
*
* @param {Inbox_Replay_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_loading = /** @type {((inputs?: Inbox_Replay_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_loading(inputs)
});
/**
* | output |
* | --- |
* | "Started {started} · last message {last}" |
*
* @param {Inbox_Replay_MetaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_meta = /** @type {((inputs: Inbox_Replay_MetaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_MetaInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_meta(inputs)
});
/**
* | output |
* | --- |
* | "Read-only" |
*
* @param {Inbox_Replay_Read_OnlyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_read_only = /** @type {((inputs?: Inbox_Replay_Read_OnlyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_Read_OnlyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_read_only(inputs)
});
/**
* | output |
* | --- |
* | "Conversation replay" |
*
* @param {Inbox_Replay_Transcript_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbox_replay_transcript_label = /** @type {((inputs?: Inbox_Replay_Transcript_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Replay_Transcript_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.inbox_replay_transcript_label(inputs)
});
/**
* | output |
* | --- |
* | "All categories" |
*
* @param {Knowledge_Category_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_category_all = /** @type {((inputs?: Knowledge_Category_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Category_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_category_all(inputs)
});
/**
* | output |
* | --- |
* | "No categories found" |
*
* @param {Knowledge_Category_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_category_empty = /** @type {((inputs?: Knowledge_Category_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Category_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_category_empty(inputs)
});
/**
* | output |
* | --- |
* | "Category" |
*
* @param {Knowledge_Category_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_category_label = /** @type {((inputs?: Knowledge_Category_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Category_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_category_label(inputs)
});
/**
* | output |
* | --- |
* | "Uncategorized" |
*
* @param {Knowledge_Category_NoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_category_none = /** @type {((inputs?: Knowledge_Category_NoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Category_NoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_category_none(inputs)
});
/**
* | output |
* | --- |
* | "Search categories" |
*
* @param {Knowledge_Category_SearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_category_search = /** @type {((inputs?: Knowledge_Category_SearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Category_SearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_category_search(inputs)
});
/**
* | output |
* | --- |
* | "Category" |
*
* @param {Knowledge_Column_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_column_category = /** @type {((inputs?: Knowledge_Column_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Column_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_column_category(inputs)
});
/**
* | output |
* | --- |
* | "Inventory" |
*
* @param {Knowledge_Column_InventoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_column_inventory = /** @type {((inputs?: Knowledge_Column_InventoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Column_InventoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_column_inventory(inputs)
});
/**
* | output |
* | --- |
* | "Price" |
*
* @param {Knowledge_Column_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_column_price = /** @type {((inputs?: Knowledge_Column_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Column_PriceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_column_price(inputs)
});
/**
* | output |
* | --- |
* | "Product" |
*
* @param {Knowledge_Column_ProductInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_column_product = /** @type {((inputs?: Knowledge_Column_ProductInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Column_ProductInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_column_product(inputs)
});
/**
* | output |
* | --- |
* | "Variants" |
*
* @param {Knowledge_Column_VariantsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_column_variants = /** @type {((inputs?: Knowledge_Column_VariantsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Column_VariantsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_column_variants(inputs)
});
/**
* | output |
* | --- |
* | "Products appear here when they are available in your Shopify store." |
*
* @param {Knowledge_Empty_Products_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_empty_products_body = /** @type {((inputs?: Knowledge_Empty_Products_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Empty_Products_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_empty_products_body(inputs)
});
/**
* | output |
* | --- |
* | "No Shopify products yet" |
*
* @param {Knowledge_Empty_Products_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_empty_products_heading = /** @type {((inputs?: Knowledge_Empty_Products_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Empty_Products_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_empty_products_heading(inputs)
});
/**
* | output |
* | --- |
* | "Published questions and answers from MyQA Online will appear here." |
*
* @param {Knowledge_Empty_Questions_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_empty_questions_body = /** @type {((inputs?: Knowledge_Empty_Questions_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Empty_Questions_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_empty_questions_body(inputs)
});
/**
* | output |
* | --- |
* | "No questions & answers yet" |
*
* @param {Knowledge_Empty_Questions_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_empty_questions_heading = /** @type {((inputs?: Knowledge_Empty_Questions_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Empty_Questions_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_empty_questions_heading(inputs)
});
/**
* | output |
* | --- |
* | "Try a different search term or clear the filters." |
*
* @param {Knowledge_Empty_Search_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_empty_search_body = /** @type {((inputs?: Knowledge_Empty_Search_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Empty_Search_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_empty_search_body(inputs)
});
/**
* | output |
* | --- |
* | "No products match your search" |
*
* @param {Knowledge_Empty_Search_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_empty_search_heading = /** @type {((inputs?: Knowledge_Empty_Search_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Empty_Search_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_empty_search_heading(inputs)
});
/**
* | output |
* | --- |
* | "Your session expired. Reopen the admin from Shopify." |
*
* @param {Knowledge_Failure_ForbiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_failure_forbidden = /** @type {((inputs?: Knowledge_Failure_ForbiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Failure_ForbiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_failure_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach GoNovus. Check your connection and try again." |
*
* @param {Knowledge_Failure_NetworkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_failure_network = /** @type {((inputs?: Knowledge_Failure_NetworkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Failure_NetworkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_failure_network(inputs)
});
/**
* | output |
* | --- |
* | "Store knowledge is unavailable right now." |
*
* @param {Knowledge_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_failure_rejected = /** @type {((inputs?: Knowledge_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Store knowledge came back in an unexpected shape." |
*
* @param {Knowledge_Failure_SchemaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_failure_schema = /** @type {((inputs?: Knowledge_Failure_SchemaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Failure_SchemaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_failure_schema(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong loading store knowledge." |
*
* @param {Knowledge_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_failure_unexpected = /** @type {((inputs?: Knowledge_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "—" |
*
* @param {Knowledge_Inventory_UntrackedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_inventory_untracked = /** @type {((inputs?: Knowledge_Inventory_UntrackedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Inventory_UntrackedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_inventory_untracked(inputs)
});
/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Knowledge_Load_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_load_more = /** @type {((inputs?: Knowledge_Load_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Load_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_load_more(inputs)
});
/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Knowledge_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_loading = /** @type {((inputs?: Knowledge_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_loading(inputs)
});
/**
* | output |
* | --- |
* | "Loading more" |
*
* @param {Knowledge_Loading_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_loading_more = /** @type {((inputs?: Knowledge_Loading_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Loading_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_loading_more(inputs)
});
/**
* | output |
* | --- |
* | "Knowledge" |
*
* @param {Knowledge_Page_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_page_title = /** @type {((inputs?: Knowledge_Page_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Page_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_page_title(inputs)
});
/**
* | output |
* | --- |
* | "{category} · {price} · Inventory {inventory} · Variants {variants}" |
*
* @param {Knowledge_Product_MetaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_product_meta = /** @type {((inputs: Knowledge_Product_MetaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Product_MetaInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_product_meta(inputs)
});
/**
* | output |
* | --- |
* | "Search products" |
*
* @param {Knowledge_Search_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_search_label = /** @type {((inputs?: Knowledge_Search_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Search_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_search_label(inputs)
});
/**
* | output |
* | --- |
* | "Search products…" |
*
* @param {Knowledge_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_search_placeholder = /** @type {((inputs?: Knowledge_Search_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Search_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_search_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Products" |
*
* @param {Knowledge_Tab_ProductsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_tab_products = /** @type {((inputs?: Knowledge_Tab_ProductsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Tab_ProductsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_tab_products(inputs)
});
/**
* | output |
* | --- |
* | "Questions & answers" |
*
* @param {Knowledge_Tab_QuestionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_tab_questions = /** @type {((inputs?: Knowledge_Tab_QuestionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Tab_QuestionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_tab_questions(inputs)
});
/**
* | output |
* | --- |
* | "Knowledge categories" |
*
* @param {Knowledge_Tabs_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_tabs_label = /** @type {((inputs?: Knowledge_Tabs_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Tabs_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_tabs_label(inputs)
});
/**
* | output |
* | --- |
* | "Test in Playground" |
*
* @param {Knowledge_Test_In_PlaygroundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const knowledge_test_in_playground = /** @type {((inputs?: Knowledge_Test_In_PlaygroundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledge_Test_In_PlaygroundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.knowledge_test_in_playground(inputs)
});
/**
* | output |
* | --- |
* | "Your session expired. Reopen the admin from Shopify." |
*
* @param {Playground_Failure_ForbiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_failure_forbidden = /** @type {((inputs?: Playground_Failure_ForbiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Failure_ForbiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_failure_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach GoNovus. Check your connection and try again." |
*
* @param {Playground_Failure_NetworkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_failure_network = /** @type {((inputs?: Playground_Failure_NetworkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Failure_NetworkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_failure_network(inputs)
});
/**
* | output |
* | --- |
* | "Could not start a test conversation right now." |
*
* @param {Playground_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_failure_rejected = /** @type {((inputs?: Playground_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "The test conversation came back in an unexpected shape." |
*
* @param {Playground_Failure_SchemaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_failure_schema = /** @type {((inputs?: Playground_Failure_SchemaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Failure_SchemaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_failure_schema(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong starting a test conversation." |
*
* @param {Playground_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_failure_unexpected = /** @type {((inputs?: Playground_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "Testing live configuration" |
*
* @param {Playground_Live_ConfigInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_live_config = /** @type {((inputs?: Playground_Live_ConfigInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Live_ConfigInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_live_config(inputs)
});
/**
* | output |
* | --- |
* | "Playground" |
*
* @param {Playground_Page_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_page_title = /** @type {((inputs?: Playground_Page_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Page_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_page_title(inputs)
});
/**
* | output |
* | --- |
* | "This test uses real customer orders and sends real emails to your support address. Sign in as the customer to check orders. New test clears authorization and..." |
*
* @param {Playground_Real_Business_NoticeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_real_business_notice = /** @type {((inputs?: Playground_Real_Business_NoticeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_Real_Business_NoticeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_real_business_notice(inputs)
});
/**
* | output |
* | --- |
* | "New test" |
*
* @param {Playground_ResetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const playground_reset = /** @type {((inputs?: Playground_ResetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playground_ResetInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.playground_reset(inputs)
});
/**
* | output |
* | --- |
* | "The name shoppers see in chat." |
*
* @param {Settings_Agent_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_agent_copy = /** @type {((inputs?: Settings_Agent_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Agent_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_agent_copy(inputs)
});
/**
* | output |
* | --- |
* | "Agent name" |
*
* @param {Settings_Agent_Name_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_agent_name_label = /** @type {((inputs?: Settings_Agent_Name_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Agent_Name_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_agent_name_label(inputs)
});
/**
* | output |
* | --- |
* | "Watercolor glass fades your theme color toward the edges and blurs the page behind the character. Very light theme colors stay solid so the eyes remain visible." |
*
* @param {Settings_Character_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_character_hint = /** @type {((inputs?: Settings_Character_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Character_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_character_hint(inputs)
});
/**
* | output |
* | --- |
* | "Character" |
*
* @param {Settings_Character_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_character_label = /** @type {((inputs?: Settings_Character_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Character_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_character_label(inputs)
});
/**
* | output |
* | --- |
* | "Solid" |
*
* @param {Settings_Character_SolidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_character_solid = /** @type {((inputs?: Settings_Character_SolidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Character_SolidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_character_solid(inputs)
});
/**
* | output |
* | --- |
* | "Watercolor glass" |
*
* @param {Settings_Character_WatercolorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_character_watercolor = /** @type {((inputs?: Settings_Character_WatercolorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Character_WatercolorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_character_watercolor(inputs)
});
/**
* | output |
* | --- |
* | "Color picker" |
*
* @param {Settings_Color_Picker_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_color_picker_label = /** @type {((inputs?: Settings_Color_Picker_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Color_Picker_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_color_picker_label(inputs)
});
/**
* | output |
* | --- |
* | "Color & shape" |
*
* @param {Settings_Color_Shape_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_color_shape_heading = /** @type {((inputs?: Settings_Color_Shape_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Color_Shape_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_color_shape_heading(inputs)
});
/**
* | output |
* | --- |
* | "Adds a copy button under each AI reply." |
*
* @param {Settings_Copy_Button_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_copy_button_copy = /** @type {((inputs?: Settings_Copy_Button_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Copy_Button_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_copy_button_copy(inputs)
});
/**
* | output |
* | --- |
* | "Let shoppers copy replies" |
*
* @param {Settings_Copy_Button_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_copy_button_title = /** @type {((inputs?: Settings_Copy_Button_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Copy_Button_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_copy_button_title(inputs)
});
/**
* | output |
* | --- |
* | "Editorial" |
*
* @param {Settings_Direction_EditorialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_direction_editorial = /** @type {((inputs?: Settings_Direction_EditorialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Direction_EditorialInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_direction_editorial(inputs)
});
/**
* | output |
* | --- |
* | "Hairline" |
*
* @param {Settings_Direction_HairlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_direction_hairline = /** @type {((inputs?: Settings_Direction_HairlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Direction_HairlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_direction_hairline(inputs)
});
/**
* | output |
* | --- |
* | "Hairline keeps thin dividers. Editorial shows assistant replies without bubble backgrounds." |
*
* @param {Settings_Direction_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_direction_hint = /** @type {((inputs?: Settings_Direction_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Direction_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_direction_hint(inputs)
});
/**
* | output |
* | --- |
* | "Style" |
*
* @param {Settings_Direction_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_direction_label = /** @type {((inputs?: Settings_Direction_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Direction_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_direction_label(inputs)
});
/**
* | output |
* | --- |
* | "Keep it visible" |
*
* @param {Settings_Disable_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_disable_cancel = /** @type {((inputs?: Settings_Disable_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Disable_CancelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_disable_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Hide chatbox" |
*
* @param {Settings_Disable_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_disable_confirm = /** @type {((inputs?: Settings_Disable_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Disable_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_disable_confirm(inputs)
});
/**
* | output |
* | --- |
* | "Shoppers stop seeing the assistant as soon as you save. Existing conversations are not deleted." |
*
* @param {Settings_Disable_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_disable_description = /** @type {((inputs?: Settings_Disable_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Disable_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_disable_description(inputs)
});
/**
* | output |
* | --- |
* | "Hide the chatbox on your storefront?" |
*
* @param {Settings_Disable_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_disable_title = /** @type {((inputs?: Settings_Disable_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Disable_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_disable_title(inputs)
});
/**
* | output |
* | --- |
* | "Discard changes" |
*
* @param {Settings_DiscardInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_discard = /** @type {((inputs?: Settings_DiscardInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_DiscardInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_discard(inputs)
});
/**
* | output |
* | --- |
* | "Enter an agent name of 1 to 40 characters." |
*
* @param {Settings_Error_Agent_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_agent_name = /** @type {((inputs?: Settings_Error_Agent_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Agent_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_agent_name(inputs)
});
/**
* | output |
* | --- |
* | "Go to {tab}" |
*
* @param {Settings_Error_Go_To_TabInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_go_to_tab = /** @type {((inputs: Settings_Error_Go_To_TabInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Go_To_TabInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_go_to_tab(inputs)
});
/**
* | output |
* | --- |
* | "A proactive rule in Proactive messages needs attention." |
*
* @param {Settings_Error_Proactive_RulesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_proactive_rules = /** @type {((inputs?: Settings_Error_Proactive_RulesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Proactive_RulesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_proactive_rules(inputs)
});
/**
* | output |
* | --- |
* | "Enter 1 to 200 characters of plain text. {placeholder} is the only placeholder." |
*
* @param {Settings_Error_Rule_PromptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_rule_prompt = /** @type {((inputs: Settings_Error_Rule_PromptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Rule_PromptInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_rule_prompt(inputs)
});
/**
* | output |
* | --- |
* | "Enter 1 to 1000 characters of plain text. {placeholder} is the only placeholder." |
*
* @param {Settings_Error_Rule_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_rule_question = /** @type {((inputs: Settings_Error_Rule_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Rule_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_rule_question(inputs)
});
/**
* | output |
* | --- |
* | "An enabled element rule needs a target element." |
*
* @param {Settings_Error_Rule_SelectorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_rule_selector = /** @type {((inputs?: Settings_Error_Rule_SelectorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Rule_SelectorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_rule_selector(inputs)
});
/**
* | output |
* | --- |
* | "Enter a whole number of seconds from 1 to 300." |
*
* @param {Settings_Error_Rule_WaitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_rule_wait = /** @type {((inputs?: Settings_Error_Rule_WaitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Rule_WaitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_rule_wait(inputs)
});
/**
* | output |
* | --- |
* | "Enter a question of 1 to 80 characters, or remove this row." |
*
* @param {Settings_Error_Suggested_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_suggested_question = /** @type {((inputs?: Settings_Error_Suggested_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Suggested_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_suggested_question(inputs)
});
/**
* | output |
* | --- |
* | "This question is already in the list." |
*
* @param {Settings_Error_Suggested_Question_DuplicateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_suggested_question_duplicate = /** @type {((inputs?: Settings_Error_Suggested_Question_DuplicateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Suggested_Question_DuplicateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_suggested_question_duplicate(inputs)
});
/**
* | output |
* | --- |
* | "Enter a valid support email address." |
*
* @param {Settings_Error_Support_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_support_email = /** @type {((inputs?: Settings_Error_Support_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Support_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_support_email(inputs)
});
/**
* | output |
* | --- |
* | "has fields that need attention." |
*
* @param {Settings_Error_Tab_FieldsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_tab_fields = /** @type {((inputs?: Settings_Error_Tab_FieldsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Tab_FieldsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_tab_fields(inputs)
});
/**
* | output |
* | --- |
* | "Enter a 6-digit Hex color, for example #E4649B." |
*
* @param {Settings_Error_Theme_ColorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_theme_color = /** @type {((inputs?: Settings_Error_Theme_ColorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Theme_ColorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_theme_color(inputs)
});
/**
* | output |
* | --- |
* | "Enter a welcome message of 1 to 80 characters." |
*
* @param {Settings_Error_Welcome_MessageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_error_welcome_message = /** @type {((inputs?: Settings_Error_Welcome_MessageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Error_Welcome_MessageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_error_welcome_message(inputs)
});
/**
* | output |
* | --- |
* | "Your session expired. Reopen the admin from Shopify." |
*
* @param {Settings_Failure_ForbiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_failure_forbidden = /** @type {((inputs?: Settings_Failure_ForbiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Failure_ForbiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_failure_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach GoNovus. Check your connection and try again." |
*
* @param {Settings_Failure_NetworkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_failure_network = /** @type {((inputs?: Settings_Failure_NetworkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Failure_NetworkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_failure_network(inputs)
});
/**
* | output |
* | --- |
* | "Settings are unavailable right now." |
*
* @param {Settings_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_failure_rejected = /** @type {((inputs?: Settings_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Settings came back in an unexpected shape." |
*
* @param {Settings_Failure_SchemaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_failure_schema = /** @type {((inputs?: Settings_Failure_SchemaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Failure_SchemaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_failure_schema(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong loading settings." |
*
* @param {Settings_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_failure_unexpected = /** @type {((inputs?: Settings_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "Applies to the whole Chatbox — the launcher, prompts and the chat window. It does not change the GoNovus admin interface." |
*
* @param {Settings_Font_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_hint = /** @type {((inputs?: Settings_Font_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_hint(inputs)
});
/**
* | output |
* | --- |
* | "Font" |
*
* @param {Settings_Font_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_label = /** @type {((inputs?: Settings_Font_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_label(inputs)
});
/**
* | output |
* | --- |
* | "Clean Sans" |
*
* @param {Settings_Font_SansInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_sans = /** @type {((inputs?: Settings_Font_SansInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_SansInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_sans(inputs)
});
/**
* | output |
* | --- |
* | "Editorial Serif" |
*
* @param {Settings_Font_SerifInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_serif = /** @type {((inputs?: Settings_Font_SerifInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_SerifInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_serif(inputs)
});
/**
* | output |
* | --- |
* | "Text size" |
*
* @param {Settings_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_size_label = /** @type {((inputs?: Settings_Font_Size_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_Size_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_size_label(inputs)
});
/**
* | output |
* | --- |
* | "Large · 16px" |
*
* @param {Settings_Font_Size_LargeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_size_large = /** @type {((inputs?: Settings_Font_Size_LargeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_Size_LargeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_size_large(inputs)
});
/**
* | output |
* | --- |
* | "Small · 13px" |
*
* @param {Settings_Font_Size_SmallInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_size_small = /** @type {((inputs?: Settings_Font_Size_SmallInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_Size_SmallInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_size_small(inputs)
});
/**
* | output |
* | --- |
* | "Standard · 14px" |
*
* @param {Settings_Font_Size_StandardInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_size_standard = /** @type {((inputs?: Settings_Font_Size_StandardInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_Size_StandardInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_size_standard(inputs)
});
/**
* | output |
* | --- |
* | "Match store theme" |
*
* @param {Settings_Font_ThemeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_font_theme = /** @type {((inputs?: Settings_Font_ThemeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Font_ThemeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_font_theme(inputs)
});
/**
* | output |
* | --- |
* | "Makes the chatbox translucent and blurs the page behind it. Busy product photos show through, so check the preview before you save." |
*
* @param {Settings_Glass_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_glass_hint = /** @type {((inputs?: Settings_Glass_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Glass_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_glass_hint(inputs)
});
/**
* | output |
* | --- |
* | "Frosted glass" |
*
* @param {Settings_Glass_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_glass_label = /** @type {((inputs?: Settings_Glass_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Glass_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_glass_label(inputs)
});
/**
* | output |
* | --- |
* | "Off" |
*
* @param {Settings_Glass_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_glass_off = /** @type {((inputs?: Settings_Glass_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Glass_OffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_glass_off(inputs)
});
/**
* | output |
* | --- |
* | "On" |
*
* @param {Settings_Glass_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_glass_on = /** @type {((inputs?: Settings_Glass_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Glass_OnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_glass_on(inputs)
});
/**
* | output |
* | --- |
* | "Requests go only to your verified support email. Reply-To lets you reply directly to the shopper." |
*
* @param {Settings_Handoff_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_handoff_copy = /** @type {((inputs?: Settings_Handoff_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Handoff_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_handoff_copy(inputs)
});
/**
* | output |
* | --- |
* | "Human handoff" |
*
* @param {Settings_Handoff_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_handoff_heading = /** @type {((inputs?: Settings_Handoff_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Handoff_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_handoff_heading(inputs)
});
/**
* | output |
* | --- |
* | "Hex value" |
*
* @param {Settings_Hex_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_hex_label = /** @type {((inputs?: Settings_Hex_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Hex_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_hex_label(inputs)
});
/**
* | output |
* | --- |
* | "Shoppers can drag it to either side. Turn off to keep it at the position above." |
*
* @param {Settings_Launcher_Drag_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_launcher_drag_copy = /** @type {((inputs?: Settings_Launcher_Drag_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Launcher_Drag_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_launcher_drag_copy(inputs)
});
/**
* | output |
* | --- |
* | "Let shoppers move the character" |
*
* @param {Settings_Launcher_Drag_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_launcher_drag_title = /** @type {((inputs?: Settings_Launcher_Drag_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Launcher_Drag_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_launcher_drag_title(inputs)
});
/**
* | output |
* | --- |
* | "Stay" |
*
* @param {Settings_Leave_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_leave_cancel = /** @type {((inputs?: Settings_Leave_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Leave_CancelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_leave_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Leave" |
*
* @param {Settings_Leave_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_leave_confirm = /** @type {((inputs?: Settings_Leave_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Leave_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_leave_confirm(inputs)
});
/**
* | output |
* | --- |
* | "Your changes have not been saved yet." |
*
* @param {Settings_Leave_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_leave_description = /** @type {((inputs?: Settings_Leave_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Leave_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_leave_description(inputs)
});
/**
* | output |
* | --- |
* | "Leave without saving?" |
*
* @param {Settings_Leave_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_leave_title = /** @type {((inputs?: Settings_Leave_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Leave_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_leave_title(inputs)
});
/**
* | output |
* | --- |
* | "Loading settings" |
*
* @param {Settings_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_loading = /** @type {((inputs?: Settings_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_loading(inputs)
});
/**
* | output |
* | --- |
* | "Brand logo" |
*
* @param {Settings_Logo_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_alt = /** @type {((inputs?: Settings_Logo_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_alt(inputs)
});
/**
* | output |
* | --- |
* | "That file is over 2 MB. Your current logo is unchanged." |
*
* @param {Settings_Logo_Failure_Too_LargeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_failure_too_large = /** @type {((inputs?: Settings_Logo_Failure_Too_LargeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_Failure_Too_LargeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_failure_too_large(inputs)
});
/**
* | output |
* | --- |
* | "Use a PNG, JPG or WebP file. Your current logo is unchanged." |
*
* @param {Settings_Logo_Failure_TypeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_failure_type = /** @type {((inputs?: Settings_Logo_Failure_TypeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_Failure_TypeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_failure_type(inputs)
});
/**
* | output |
* | --- |
* | "Could not upload that logo. Your current logo is unchanged." |
*
* @param {Settings_Logo_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_failure_unexpected = /** @type {((inputs?: Settings_Logo_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "Logo file" |
*
* @param {Settings_Logo_File_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_file_label = /** @type {((inputs?: Settings_Logo_File_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_File_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_file_label(inputs)
});
/**
* | output |
* | --- |
* | "PNG, JPG or WebP, up to 2 MB. A square image works best. Shoppers see it in the chat header." |
*
* @param {Settings_Logo_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_hint = /** @type {((inputs?: Settings_Logo_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_hint(inputs)
});
/**
* | output |
* | --- |
* | "Brand logo" |
*
* @param {Settings_Logo_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_label = /** @type {((inputs?: Settings_Logo_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_label(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Settings_Logo_RemoveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_remove = /** @type {((inputs?: Settings_Logo_RemoveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_RemoveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_remove(inputs)
});
/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Settings_Logo_ReplaceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_replace = /** @type {((inputs?: Settings_Logo_ReplaceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_ReplaceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_replace(inputs)
});
/**
* | output |
* | --- |
* | "Upload logo" |
*
* @param {Settings_Logo_UploadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_logo_upload = /** @type {((inputs?: Settings_Logo_UploadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Logo_UploadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_logo_upload(inputs)
});
/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Settings_Messages_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_messages_heading = /** @type {((inputs?: Settings_Messages_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Messages_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_messages_heading(inputs)
});
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Settings_Page_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_page_title = /** @type {((inputs?: Settings_Page_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Page_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_page_title(inputs)
});
/**
* | output |
* | --- |
* | "Bottom left" |
*
* @param {Settings_Position_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_position_bottom_left = /** @type {((inputs?: Settings_Position_Bottom_LeftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Position_Bottom_LeftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_position_bottom_left(inputs)
});
/**
* | output |
* | --- |
* | "Bottom right" |
*
* @param {Settings_Position_Bottom_RightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_position_bottom_right = /** @type {((inputs?: Settings_Position_Bottom_RightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Position_Bottom_RightInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_position_bottom_right(inputs)
});
/**
* | output |
* | --- |
* | "Position" |
*
* @param {Settings_Position_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_position_label = /** @type {((inputs?: Settings_Position_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Position_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_position_label(inputs)
});
/**
* | output |
* | --- |
* | "Chat window" |
*
* @param {Settings_Preview_ConversationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_conversation = /** @type {((inputs?: Settings_Preview_ConversationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_ConversationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_conversation(inputs)
});
/**
* | output |
* | --- |
* | "Desktop" |
*
* @param {Settings_Preview_DesktopInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_desktop = /** @type {((inputs?: Settings_Preview_DesktopInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_DesktopInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_desktop(inputs)
});
/**
* | output |
* | --- |
* | "Preview device" |
*
* @param {Settings_Preview_Device_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_device_label = /** @type {((inputs?: Settings_Preview_Device_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_Device_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_device_label(inputs)
});
/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Settings_Preview_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_heading = /** @type {((inputs?: Settings_Preview_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_heading(inputs)
});
/**
* | output |
* | --- |
* | "Chatbox hidden on storefront" |
*
* @param {Settings_Preview_HiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_hidden = /** @type {((inputs?: Settings_Preview_HiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_HiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_hidden(inputs)
});
/**
* | output |
* | --- |
* | "Launcher" |
*
* @param {Settings_Preview_LauncherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_launcher = /** @type {((inputs?: Settings_Preview_LauncherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_LauncherInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_launcher(inputs)
});
/**
* | output |
* | --- |
* | "Mobile" |
*
* @param {Settings_Preview_MobileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_mobile = /** @type {((inputs?: Settings_Preview_MobileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_MobileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_mobile(inputs)
});
/**
* | output |
* | --- |
* | "Proactive prompt" |
*
* @param {Settings_Preview_ProactiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_proactive = /** @type {((inputs?: Settings_Preview_ProactiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_ProactiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_proactive(inputs)
});
/**
* | output |
* | --- |
* | "YOUR STORE" |
*
* @param {Settings_Preview_Store_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_store_name = /** @type {((inputs?: Settings_Preview_Store_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_Store_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_store_name(inputs)
});
/**
* | output |
* | --- |
* | "Preview view" |
*
* @param {Settings_Preview_View_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_view_label = /** @type {((inputs?: Settings_Preview_View_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_View_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_preview_view_label(inputs)
});
/**
* | output |
* | --- |
* | "Add rule" |
*
* @param {Settings_Proactive_AddInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_add = /** @type {((inputs?: Settings_Proactive_AddInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_AddInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_add(inputs)
});
/**
* | output |
* | --- |
* | "Welcome shoppers or offer help as they browse. Rules run top to bottom and the first match shows its prompt. Changes apply when you save." |
*
* @param {Settings_Proactive_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_copy = /** @type {((inputs?: Settings_Proactive_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_copy(inputs)
});
/**
* | output |
* | --- |
* | "Delete rule {position}" |
*
* @param {Settings_Proactive_DeleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_delete = /** @type {((inputs: Settings_Proactive_DeleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_DeleteInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_delete(inputs)
});
/**
* | output |
* | --- |
* | "Keep rule" |
*
* @param {Settings_Proactive_Delete_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_delete_cancel = /** @type {((inputs?: Settings_Proactive_Delete_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Delete_CancelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_delete_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Delete rule" |
*
* @param {Settings_Proactive_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_delete_confirm = /** @type {((inputs?: Settings_Proactive_Delete_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Delete_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_delete_confirm(inputs)
});
/**
* | output |
* | --- |
* | "The rule is removed when you save changes." |
*
* @param {Settings_Proactive_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_delete_description = /** @type {((inputs?: Settings_Proactive_Delete_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Delete_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_delete_description(inputs)
});
/**
* | output |
* | --- |
* | "Delete this rule?" |
*
* @param {Settings_Proactive_Delete_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_delete_title = /** @type {((inputs?: Settings_Proactive_Delete_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Delete_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Edit rule {position}" |
*
* @param {Settings_Proactive_EditInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_edit = /** @type {((inputs: Settings_Proactive_EditInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_EditInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_edit(inputs)
});
/**
* | output |
* | --- |
* | "Add a rule to welcome shoppers when they enter your store, help when they linger on a product page, or respond when an element stays on screen." |
*
* @param {Settings_Proactive_Empty_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_empty_body = /** @type {((inputs?: Settings_Proactive_Empty_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Empty_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_empty_body(inputs)
});
/**
* | output |
* | --- |
* | "No proactive rules" |
*
* @param {Settings_Proactive_Empty_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_empty_heading = /** @type {((inputs?: Settings_Proactive_Empty_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Empty_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_empty_heading(inputs)
});
/**
* | output |
* | --- |
* | "Enable rule {position}" |
*
* @param {Settings_Proactive_EnableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_enable = /** @type {((inputs: Settings_Proactive_EnableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_EnableInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_enable(inputs)
});
/**
* | output |
* | --- |
* | "{count} / {max}" |
*
* @param {Settings_Proactive_Field_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_field_count = /** @type {((inputs: Settings_Proactive_Field_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Field_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_field_count(inputs)
});
/**
* | output |
* | --- |
* | "Proactive messages" |
*
* @param {Settings_Proactive_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_heading = /** @type {((inputs?: Settings_Proactive_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_heading(inputs)
});
/**
* | output |
* | --- |
* | "Insert {placeholder}" |
*
* @param {Settings_Proactive_Insert_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_insert_placeholder = /** @type {((inputs: Settings_Proactive_Insert_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Insert_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_insert_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Move rule {position} down" |
*
* @param {Settings_Proactive_Move_DownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_move_down = /** @type {((inputs: Settings_Proactive_Move_DownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Move_DownInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_move_down(inputs)
});
/**
* | output |
* | --- |
* | "Move rule {position} up" |
*
* @param {Settings_Proactive_Move_UpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_move_up = /** @type {((inputs: Settings_Proactive_Move_UpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Move_UpInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_move_up(inputs)
});
/**
* | output |
* | --- |
* | "No prompt yet" |
*
* @param {Settings_Proactive_No_PromptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_no_prompt = /** @type {((inputs?: Settings_Proactive_No_PromptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_No_PromptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_no_prompt(inputs)
});
/**
* | output |
* | --- |
* | "Pick element" |
*
* @param {Settings_Proactive_PickInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick = /** @type {((inputs?: Settings_Proactive_PickInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_PickInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick(inputs)
});
/**
* | output |
* | --- |
* | "Pick a different element" |
*
* @param {Settings_Proactive_Pick_AgainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_again = /** @type {((inputs?: Settings_Proactive_Pick_AgainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_AgainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_again(inputs)
});
/**
* | output |
* | --- |
* | "Picked element applied to the rule." |
*
* @param {Settings_Proactive_Pick_AppliedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_applied = /** @type {((inputs?: Settings_Proactive_Pick_AppliedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_AppliedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_applied(inputs)
});
/**
* | output |
* | --- |
* | "Finish or cancel picking before saving changes." |
*
* @param {Settings_Proactive_Pick_BlockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_blocked = /** @type {((inputs?: Settings_Proactive_Pick_BlockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_BlockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Cancel picking" |
*
* @param {Settings_Proactive_Pick_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_cancel = /** @type {((inputs?: Settings_Proactive_Pick_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_CancelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Could not confirm the pick was canceled — the storefront may still write to this rule. Try again." |
*
* @param {Settings_Proactive_Pick_Cancel_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_cancel_failed = /** @type {((inputs?: Settings_Proactive_Pick_Cancel_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Cancel_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_cancel_failed(inputs)
});
/**
* | output |
* | --- |
* | "A new target element was saved on your storefront. Apply it to this draft or keep your edits." |
*
* @param {Settings_Proactive_Pick_ConflictInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_conflict = /** @type {((inputs?: Settings_Proactive_Pick_ConflictInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_ConflictInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_conflict(inputs)
});
/**
* | output |
* | --- |
* | "Apply or dismiss the picked element in Proactive messages before saving." |
*
* @param {Settings_Proactive_Pick_Conflict_BlockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_conflict_blocked = /** @type {((inputs?: Settings_Proactive_Pick_Conflict_BlockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Conflict_BlockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_conflict_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Settings_Proactive_Pick_DismissInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_dismiss = /** @type {((inputs?: Settings_Proactive_Pick_DismissInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_DismissInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_dismiss(inputs)
});
/**
* | output |
* | --- |
* | "Picking runs on your storefront and needs the GoNovus app embed enabled in your theme. The chatbox itself can stay hidden." |
*
* @param {Settings_Proactive_Pick_Embed_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_embed_hint = /** @type {((inputs?: Settings_Proactive_Pick_Embed_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Embed_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_embed_hint(inputs)
});
/**
* | output |
* | --- |
* | "Your browser blocked the new tab. Allow pop-ups and try again." |
*
* @param {Settings_Proactive_Pick_Failure_PopupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_failure_popup = /** @type {((inputs?: Settings_Proactive_Pick_Failure_PopupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Failure_PopupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_failure_popup(inputs)
});
/**
* | output |
* | --- |
* | "Could not start picking for this rule. Refresh the page and try again." |
*
* @param {Settings_Proactive_Pick_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_failure_rejected = /** @type {((inputs?: Settings_Proactive_Pick_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Could not start picking. Try again." |
*
* @param {Settings_Proactive_Pick_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_failure_unexpected = /** @type {((inputs?: Settings_Proactive_Pick_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "This rule was deleted or changed while you were picking — nothing was applied." |
*
* @param {Settings_Proactive_Pick_GoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_gone = /** @type {((inputs?: Settings_Proactive_Pick_GoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_GoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_gone(inputs)
});
/**
* | output |
* | --- |
* | "Keep my edits" |
*
* @param {Settings_Proactive_Pick_KeepInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_keep = /** @type {((inputs?: Settings_Proactive_Pick_KeepInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_KeepInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_keep(inputs)
});
/**
* | output |
* | --- |
* | "Save changes to pick an element on your storefront." |
*
* @param {Settings_Proactive_Pick_Save_FirstInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_save_first = /** @type {((inputs?: Settings_Proactive_Pick_Save_FirstInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_Save_FirstInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_save_first(inputs)
});
/**
* | output |
* | --- |
* | "Use picked element" |
*
* @param {Settings_Proactive_Pick_UseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_pick_use = /** @type {((inputs?: Settings_Proactive_Pick_UseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Pick_UseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_pick_use(inputs)
});
/**
* | output |
* | --- |
* | "Picking on your storefront — this rule updates when you come back." |
*
* @param {Settings_Proactive_PickingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_picking = /** @type {((inputs?: Settings_Proactive_PickingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_PickingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_picking(inputs)
});
/**
* | output |
* | --- |
* | "Replaces the chat button when this rule matches. Tapping it opens the chat with this as the assistant's message. {placeholder} inserts the product title." |
*
* @param {Settings_Proactive_Prompt_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_prompt_hint = /** @type {((inputs: Settings_Proactive_Prompt_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Prompt_HintInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_prompt_hint(inputs)
});
/**
* | output |
* | --- |
* | "Prompt" |
*
* @param {Settings_Proactive_Prompt_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_prompt_label = /** @type {((inputs?: Settings_Proactive_Prompt_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Prompt_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_prompt_label(inputs)
});
/**
* | output |
* | --- |
* | "Prefilled in the message box when the shopper opens the prompt. They can edit it before sending. {placeholder} inserts the product title." |
*
* @param {Settings_Proactive_Question_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_question_hint = /** @type {((inputs: Settings_Proactive_Question_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Question_HintInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_question_hint(inputs)
});
/**
* | output |
* | --- |
* | "Prefilled question" |
*
* @param {Settings_Proactive_Question_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_question_label = /** @type {((inputs?: Settings_Proactive_Question_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Question_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_question_label(inputs)
});
/**
* | output |
* | --- |
* | "Rule {position}" |
*
* @param {Settings_Proactive_RuleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_rule = /** @type {((inputs: Settings_Proactive_RuleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_RuleInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_rule(inputs)
});
/**
* | output |
* | --- |
* | "A CSS selector that matches exactly one element, without #ids. Clearing the target turns the rule off." |
*
* @param {Settings_Proactive_Selector_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_selector_hint = /** @type {((inputs?: Settings_Proactive_Selector_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Selector_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_selector_hint(inputs)
});
/**
* | output |
* | --- |
* | "Target element" |
*
* @param {Settings_Proactive_Selector_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_selector_label = /** @type {((inputs?: Settings_Proactive_Selector_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Selector_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_selector_label(inputs)
});
/**
* | output |
* | --- |
* | "This rule stays off until you pick or enter a target element. To pick one, fill in the prompt and prefilled question, save changes, then choose Pick element." |
*
* @param {Settings_Proactive_Target_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_target_required = /** @type {((inputs?: Settings_Proactive_Target_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Target_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_target_required(inputs)
});
/**
* | output |
* | --- |
* | "Element visible" |
*
* @param {Settings_Proactive_Trigger_ElementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_element = /** @type {((inputs?: Settings_Proactive_Trigger_ElementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_ElementInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_element(inputs)
});
/**
* | output |
* | --- |
* | "Show the prompt after the target element stays on screen for this long." |
*
* @param {Settings_Proactive_Trigger_Element_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_element_hint = /** @type {((inputs?: Settings_Proactive_Trigger_Element_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_Element_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_element_hint(inputs)
});
/**
* | output |
* | --- |
* | "Store entry" |
*
* @param {Settings_Proactive_Trigger_EntryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_entry = /** @type {((inputs?: Settings_Proactive_Trigger_EntryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_EntryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_entry(inputs)
});
/**
* | output |
* | --- |
* | "Welcome shoppers on any page, once per browser tab. Scrolling and clicking do not restart the wait. Skip this welcome if chat has already been opened or any ..." |
*
* @param {Settings_Proactive_Trigger_Entry_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_entry_hint = /** @type {((inputs?: Settings_Proactive_Trigger_Entry_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_Entry_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_entry_hint(inputs)
});
/**
* | output |
* | --- |
* | "Product page idle" |
*
* @param {Settings_Proactive_Trigger_IdleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_idle = /** @type {((inputs?: Settings_Proactive_Trigger_IdleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_IdleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_idle(inputs)
});
/**
* | output |
* | --- |
* | "Show the prompt after the shopper spends this long on a product page without scrolling, clicking or typing." |
*
* @param {Settings_Proactive_Trigger_Idle_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_idle_hint = /** @type {((inputs?: Settings_Proactive_Trigger_Idle_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_Idle_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_idle_hint(inputs)
});
/**
* | output |
* | --- |
* | "Trigger" |
*
* @param {Settings_Proactive_Trigger_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_trigger_label = /** @type {((inputs?: Settings_Proactive_Trigger_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Trigger_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_trigger_label(inputs)
});
/**
* | output |
* | --- |
* | "Wait before showing" |
*
* @param {Settings_Proactive_Wait_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_wait_label = /** @type {((inputs?: Settings_Proactive_Wait_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Wait_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_wait_label(inputs)
});
/**
* | output |
* | --- |
* | "seconds" |
*
* @param {Settings_Proactive_Wait_SuffixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_proactive_wait_suffix = /** @type {((inputs?: Settings_Proactive_Wait_SuffixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Proactive_Wait_SuffixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_proactive_wait_suffix(inputs)
});
/**
* | output |
* | --- |
* | "Expanded character" |
*
* @param {Settings_Prompt_Style_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_prompt_style_body = /** @type {((inputs?: Settings_Prompt_Style_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prompt_Style_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_prompt_style_body(inputs)
});
/**
* | output |
* | --- |
* | "Separate bubble" |
*
* @param {Settings_Prompt_Style_BubbleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_prompt_style_bubble = /** @type {((inputs?: Settings_Prompt_Style_BubbleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prompt_Style_BubbleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_prompt_style_bubble(inputs)
});
/**
* | output |
* | --- |
* | "Applies to all proactive prompts on desktop and mobile. Preview it using the Proactive prompt view." |
*
* @param {Settings_Prompt_Style_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_prompt_style_hint = /** @type {((inputs?: Settings_Prompt_Style_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prompt_Style_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_prompt_style_hint(inputs)
});
/**
* | output |
* | --- |
* | "Prompt style" |
*
* @param {Settings_Prompt_Style_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_prompt_style_label = /** @type {((inputs?: Settings_Prompt_Style_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prompt_Style_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_prompt_style_label(inputs)
});
/**
* | output |
* | --- |
* | "Corners" |
*
* @param {Settings_Radius_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_radius_label = /** @type {((inputs?: Settings_Radius_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Radius_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_radius_label(inputs)
});
/**
* | output |
* | --- |
* | "Preset" |
*
* @param {Settings_Radius_PresetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_radius_preset = /** @type {((inputs?: Settings_Radius_PresetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Radius_PresetInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_radius_preset(inputs)
});
/**
* | output |
* | --- |
* | "Extra rounded" |
*
* @param {Settings_Radius_RoundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_radius_round = /** @type {((inputs?: Settings_Radius_RoundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Radius_RoundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_radius_round(inputs)
});
/**
* | output |
* | --- |
* | "Rounded" |
*
* @param {Settings_Radius_RoundedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_radius_rounded = /** @type {((inputs?: Settings_Radius_RoundedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Radius_RoundedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_radius_rounded(inputs)
});
/**
* | output |
* | --- |
* | "Square" |
*
* @param {Settings_Radius_SquareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_radius_square = /** @type {((inputs?: Settings_Radius_SquareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Radius_SquareInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_radius_square(inputs)
});
/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Settings_SaveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_save = /** @type {((inputs?: Settings_SaveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_SaveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_save(inputs)
});
/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Settings_Save_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_save_failed = /** @type {((inputs?: Settings_Save_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "The server rejected these settings. Check the fields and try again." |
*
* @param {Settings_Save_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_save_failure_rejected = /** @type {((inputs?: Settings_Save_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_save_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong saving your settings." |
*
* @param {Settings_Save_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_save_failure_unexpected = /** @type {((inputs?: Settings_Save_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_save_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "Changes apply to Playground and the embedded storefront after saving." |
*
* @param {Settings_Save_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_save_hint = /** @type {((inputs?: Settings_Save_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_save_hint(inputs)
});
/**
* | output |
* | --- |
* | "Settings saved" |
*
* @param {Settings_Save_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_save_success = /** @type {((inputs?: Settings_Save_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_save_success(inputs)
});
/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Settings_SavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_saved = /** @type {((inputs?: Settings_SavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_SavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_saved(inputs)
});
/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Settings_SavingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_saving = /** @type {((inputs?: Settings_SavingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_SavingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_saving(inputs)
});
/**
* | output |
* | --- |
* | "Suggested question {position}" |
*
* @param {Settings_Suggested_Question_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_question_label = /** @type {((inputs: Settings_Suggested_Question_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Question_LabelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_question_label(inputs)
});
/**
* | output |
* | --- |
* | "Move suggested question {position} down" |
*
* @param {Settings_Suggested_Question_Move_DownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_question_move_down = /** @type {((inputs: Settings_Suggested_Question_Move_DownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Question_Move_DownInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_question_move_down(inputs)
});
/**
* | output |
* | --- |
* | "Move suggested question {position} up" |
*
* @param {Settings_Suggested_Question_Move_UpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_question_move_up = /** @type {((inputs: Settings_Suggested_Question_Move_UpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Question_Move_UpInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_question_move_up(inputs)
});
/**
* | output |
* | --- |
* | "Remove suggested question {position}" |
*
* @param {Settings_Suggested_Question_RemoveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_question_remove = /** @type {((inputs: Settings_Suggested_Question_RemoveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Question_RemoveInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_question_remove(inputs)
});
/**
* | output |
* | --- |
* | "Add question" |
*
* @param {Settings_Suggested_Questions_AddInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_questions_add = /** @type {((inputs?: Settings_Suggested_Questions_AddInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Questions_AddInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_questions_add(inputs)
});
/**
* | output |
* | --- |
* | "Listed under the welcome message before shoppers send anything. Tapping one asks it for them. Up to 80 characters each." |
*
* @param {Settings_Suggested_Questions_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_questions_hint = /** @type {((inputs?: Settings_Suggested_Questions_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Questions_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_questions_hint(inputs)
});
/**
* | output |
* | --- |
* | "Suggested questions" |
*
* @param {Settings_Suggested_Questions_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_questions_label = /** @type {((inputs?: Settings_Suggested_Questions_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Questions_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_questions_label(inputs)
});
/**
* | output |
* | --- |
* | "Up to 3 questions" |
*
* @param {Settings_Suggested_Questions_LimitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_suggested_questions_limit = /** @type {((inputs?: Settings_Suggested_Questions_LimitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Suggested_Questions_LimitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_suggested_questions_limit(inputs)
});
/**
* | output |
* | --- |
* | "Used for product, policy and pre-sale questions." |
*
* @param {Settings_Support_Email_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_email_hint = /** @type {((inputs?: Settings_Support_Email_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Email_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_email_hint(inputs)
});
/**
* | output |
* | --- |
* | "Support email" |
*
* @param {Settings_Support_Email_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_email_label = /** @type {((inputs?: Settings_Support_Email_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Email_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_email_label(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong on our side, not with your address. Try again in a few minutes." |
*
* @param {Settings_Support_Failed_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_failed_body = /** @type {((inputs?: Settings_Support_Failed_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Failed_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_failed_body(inputs)
});
/**
* | output |
* | --- |
* | "Couldn’t send the verification email" |
*
* @param {Settings_Support_Failed_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_failed_title = /** @type {((inputs?: Settings_Support_Failed_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Failed_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_failed_title(inputs)
});
/**
* | output |
* | --- |
* | "Save changes to send a verification link to this address." |
*
* @param {Settings_Support_Hint_UnsavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_hint_unsaved = /** @type {((inputs?: Settings_Support_Hint_UnsavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Hint_UnsavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_hint_unsaved(inputs)
});
/**
* | output |
* | --- |
* | "Customer requests are emailed here." |
*
* @param {Settings_Support_Hint_VerifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_hint_verified = /** @type {((inputs?: Settings_Support_Hint_VerifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Hint_VerifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_hint_verified(inputs)
});
/**
* | output |
* | --- |
* | "Not saved" |
*
* @param {Settings_Support_Mark_UnsavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_mark_unsaved = /** @type {((inputs?: Settings_Support_Mark_UnsavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Mark_UnsavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_mark_unsaved(inputs)
});
/**
* | output |
* | --- |
* | "Not verified" |
*
* @param {Settings_Support_Mark_UnverifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_mark_unverified = /** @type {((inputs?: Settings_Support_Mark_UnverifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Mark_UnverifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_mark_unverified(inputs)
});
/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Settings_Support_Mark_VerifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_mark_verified = /** @type {((inputs?: Settings_Support_Mark_VerifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Mark_VerifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_mark_verified(inputs)
});
/**
* | output |
* | --- |
* | "We sent it to {email}. Customer requests won’t be emailed until you open the link. It expires in 24 hours." |
*
* @param {Settings_Support_Pending_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_pending_body = /** @type {((inputs: Settings_Support_Pending_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Pending_BodyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_pending_body(inputs)
});
/**
* | output |
* | --- |
* | "Check your inbox for a verification link" |
*
* @param {Settings_Support_Pending_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_pending_title = /** @type {((inputs?: Settings_Support_Pending_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Pending_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_pending_title(inputs)
});
/**
* | output |
* | --- |
* | "Resend verification email" |
*
* @param {Settings_Support_ResendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_resend = /** @type {((inputs?: Settings_Support_ResendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_ResendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_resend(inputs)
});
/**
* | output |
* | --- |
* | "Resend in {seconds}s" |
*
* @param {Settings_Support_Resend_WaitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_resend_wait = /** @type {((inputs: Settings_Support_Resend_WaitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Resend_WaitInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_resend_wait(inputs)
});
/**
* | output |
* | --- |
* | "Use the link in the newest email. Links in earlier emails no longer work." |
*
* @param {Settings_Support_Resent_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_resent_body = /** @type {((inputs?: Settings_Support_Resent_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Resent_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_resent_body(inputs)
});
/**
* | output |
* | --- |
* | "New verification email sent" |
*
* @param {Settings_Support_Resent_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_resent_title = /** @type {((inputs?: Settings_Support_Resent_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Resent_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_resent_title(inputs)
});
/**
* | output |
* | --- |
* | "Send verification email" |
*
* @param {Settings_Support_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_send = /** @type {((inputs?: Settings_Support_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_send(inputs)
});
/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Settings_Support_SendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_sending = /** @type {((inputs?: Settings_Support_SendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_SendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_sending(inputs)
});
/**
* | output |
* | --- |
* | "Sent at {time}" |
*
* @param {Settings_Support_Sent_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_sent_at = /** @type {((inputs: Settings_Support_Sent_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Sent_AtInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_sent_at(inputs)
});
/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Settings_Support_Try_AgainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_try_again = /** @type {((inputs?: Settings_Support_Try_AgainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Try_AgainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_try_again(inputs)
});
/**
* | output |
* | --- |
* | "Email sending isn’t set up yet. Try again later, or contact GoNovus support if this keeps happening." |
*
* @param {Settings_Support_Unavailable_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_unavailable_body = /** @type {((inputs?: Settings_Support_Unavailable_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Unavailable_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_unavailable_body(inputs)
});
/**
* | output |
* | --- |
* | "Verification emails aren’t available right now" |
*
* @param {Settings_Support_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_unavailable_title = /** @type {((inputs?: Settings_Support_Unavailable_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Unavailable_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_unavailable_title(inputs)
});
/**
* | output |
* | --- |
* | "We’ll send a verification link to {email}. Customer requests won’t be emailed until you open it." |
*
* @param {Settings_Support_Unsent_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_unsent_body = /** @type {((inputs: Settings_Support_Unsent_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Unsent_BodyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_unsent_body(inputs)
});
/**
* | output |
* | --- |
* | "Verify this address to receive requests" |
*
* @param {Settings_Support_Unsent_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_support_unsent_title = /** @type {((inputs?: Settings_Support_Unsent_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Unsent_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_support_unsent_title(inputs)
});
/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Settings_Surface_DarkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_surface_dark = /** @type {((inputs?: Settings_Surface_DarkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Surface_DarkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_surface_dark(inputs)
});
/**
* | output |
* | --- |
* | "Pick the one that matches your storefront. Text and border colors are derived from it." |
*
* @param {Settings_Surface_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_surface_hint = /** @type {((inputs?: Settings_Surface_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Surface_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_surface_hint(inputs)
});
/**
* | output |
* | --- |
* | "Background" |
*
* @param {Settings_Surface_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_surface_label = /** @type {((inputs?: Settings_Surface_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Surface_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_surface_label(inputs)
});
/**
* | output |
* | --- |
* | "Light" |
*
* @param {Settings_Surface_LightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_surface_light = /** @type {((inputs?: Settings_Surface_LightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Surface_LightInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_surface_light(inputs)
});
/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Settings_Swatch_CustomInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_custom = /** @type {((inputs?: Settings_Swatch_CustomInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_CustomInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_custom(inputs)
});
/**
* | output |
* | --- |
* | "Default" |
*
* @param {Settings_Swatch_DefaultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_default = /** @type {((inputs?: Settings_Swatch_DefaultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_DefaultInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_default(inputs)
});
/**
* | output |
* | --- |
* | "Forest" |
*
* @param {Settings_Swatch_ForestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_forest = /** @type {((inputs?: Settings_Swatch_ForestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_ForestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_forest(inputs)
});
/**
* | output |
* | --- |
* | "Indigo" |
*
* @param {Settings_Swatch_IndigoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_indigo = /** @type {((inputs?: Settings_Swatch_IndigoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_IndigoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_indigo(inputs)
});
/**
* | output |
* | --- |
* | "Luxury" |
*
* @param {Settings_Swatch_LuxuryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_luxury = /** @type {((inputs?: Settings_Swatch_LuxuryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_LuxuryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_luxury(inputs)
});
/**
* | output |
* | --- |
* | "Minimal" |
*
* @param {Settings_Swatch_MinimalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_minimal = /** @type {((inputs?: Settings_Swatch_MinimalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_MinimalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_minimal(inputs)
});
/**
* | output |
* | --- |
* | "Playful" |
*
* @param {Settings_Swatch_PlayfulInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_playful = /** @type {((inputs?: Settings_Swatch_PlayfulInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_PlayfulInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_playful(inputs)
});
/**
* | output |
* | --- |
* | "Rose" |
*
* @param {Settings_Swatch_RoseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_rose = /** @type {((inputs?: Settings_Swatch_RoseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_RoseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_rose(inputs)
});
/**
* | output |
* | --- |
* | "Warm" |
*
* @param {Settings_Swatch_WarmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_swatch_warm = /** @type {((inputs?: Settings_Swatch_WarmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Swatch_WarmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_swatch_warm(inputs)
});
/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Settings_Tab_AppearanceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tab_appearance = /** @type {((inputs?: Settings_Tab_AppearanceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_AppearanceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tab_appearance(inputs)
});
/**
* | output |
* | --- |
* | "Chat window" |
*
* @param {Settings_Tab_Chat_WindowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tab_chat_window = /** @type {((inputs?: Settings_Tab_Chat_WindowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_Chat_WindowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tab_chat_window(inputs)
});
/**
* | output |
* | --- |
* | "Human handoff" |
*
* @param {Settings_Tab_HandoffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tab_handoff = /** @type {((inputs?: Settings_Tab_HandoffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_HandoffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tab_handoff(inputs)
});
/**
* | output |
* | --- |
* | "Launcher" |
*
* @param {Settings_Tab_LauncherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tab_launcher = /** @type {((inputs?: Settings_Tab_LauncherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_LauncherInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tab_launcher(inputs)
});
/**
* | output |
* | --- |
* | "needs attention" |
*
* @param {Settings_Tab_Needs_AttentionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tab_needs_attention = /** @type {((inputs?: Settings_Tab_Needs_AttentionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_Needs_AttentionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tab_needs_attention(inputs)
});
/**
* | output |
* | --- |
* | "Proactive messages" |
*
* @param {Settings_Tab_ProactiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tab_proactive = /** @type {((inputs?: Settings_Tab_ProactiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_ProactiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tab_proactive(inputs)
});
/**
* | output |
* | --- |
* | "Settings sections" |
*
* @param {Settings_Tabs_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_tabs_label = /** @type {((inputs?: Settings_Tabs_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tabs_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_tabs_label(inputs)
});
/**
* | output |
* | --- |
* | "Text" |
*
* @param {Settings_Text_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_text_heading = /** @type {((inputs?: Settings_Text_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Text_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_text_heading(inputs)
});
/**
* | output |
* | --- |
* | "Presets apply matching text, background, header and corners. Use the color picker or Hex value for a custom color. The preview updates before you save." |
*
* @param {Settings_Theme_Color_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_color_hint = /** @type {((inputs?: Settings_Theme_Color_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_Color_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_theme_color_hint(inputs)
});
/**
* | output |
* | --- |
* | "Theme color" |
*
* @param {Settings_Theme_Color_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_color_label = /** @type {((inputs?: Settings_Theme_Color_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_Color_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_theme_color_label(inputs)
});
/**
* | output |
* | --- |
* | "Open theme editor" |
*
* @param {Settings_Theme_EditorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_editor = /** @type {((inputs?: Settings_Theme_EditorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_EditorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_theme_editor(inputs)
});
/**
* | output |
* | --- |
* | "Title bar" |
*
* @param {Settings_Title_Bar_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_title_bar_heading = /** @type {((inputs?: Settings_Title_Bar_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Title_Bar_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_title_bar_heading(inputs)
});
/**
* | output |
* | --- |
* | "Applies after you save." |
*
* @param {Settings_Visibility_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_visibility_pending = /** @type {((inputs?: Settings_Visibility_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Visibility_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_visibility_pending(inputs)
});
/**
* | output |
* | --- |
* | "Show chatbox on storefront" |
*
* @param {Settings_Visibility_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_visibility_title = /** @type {((inputs?: Settings_Visibility_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Visibility_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_visibility_title(inputs)
});
/**
* | output |
* | --- |
* | "{count} / {max}" |
*
* @param {Settings_Welcome_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_welcome_count = /** @type {((inputs: Settings_Welcome_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Welcome_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_welcome_count(inputs)
});
/**
* | output |
* | --- |
* | "Welcome screen" |
*
* @param {Settings_Welcome_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_welcome_heading = /** @type {((inputs?: Settings_Welcome_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Welcome_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_welcome_heading(inputs)
});
/**
* | output |
* | --- |
* | "Shown when shoppers first open chat." |
*
* @param {Settings_Welcome_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_welcome_hint = /** @type {((inputs?: Settings_Welcome_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Welcome_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_welcome_hint(inputs)
});
/**
* | output |
* | --- |
* | "Welcome message" |
*
* @param {Settings_Welcome_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_welcome_label = /** @type {((inputs?: Settings_Welcome_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Welcome_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.settings_welcome_label(inputs)
});
/**
* | output |
* | --- |
* | "Unable to load your store" |
*
* @param {Store_Connection_Error_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_error_heading = /** @type {((inputs?: Store_Connection_Error_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Error_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_error_heading(inputs)
});
/**
* | output |
* | --- |
* | "Session expired" |
*
* @param {Store_Connection_Expired_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_expired_heading = /** @type {((inputs?: Store_Connection_Expired_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Expired_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_expired_heading(inputs)
});
/**
* | output |
* | --- |
* | "Your session expired. Reopen the admin from Shopify." |
*
* @param {Store_Connection_Failure_ForbiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_failure_forbidden = /** @type {((inputs?: Store_Connection_Failure_ForbiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Failure_ForbiddenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_failure_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach GoNovus. Check your connection and try again." |
*
* @param {Store_Connection_Failure_NetworkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_failure_network = /** @type {((inputs?: Store_Connection_Failure_NetworkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Failure_NetworkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_failure_network(inputs)
});
/**
* | output |
* | --- |
* | "Store details are unavailable right now." |
*
* @param {Store_Connection_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_failure_rejected = /** @type {((inputs?: Store_Connection_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_failure_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Store details came back in an unexpected shape." |
*
* @param {Store_Connection_Failure_SchemaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_failure_schema = /** @type {((inputs?: Store_Connection_Failure_SchemaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Failure_SchemaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_failure_schema(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong loading store details." |
*
* @param {Store_Connection_Failure_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_failure_unexpected = /** @type {((inputs?: Store_Connection_Failure_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Failure_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_failure_unexpected(inputs)
});
/**
* | output |
* | --- |
* | "We are finishing setup for your store. Please check back shortly." |
*
* @param {Store_Connection_Preparing_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_preparing_body = /** @type {((inputs?: Store_Connection_Preparing_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Preparing_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_preparing_body(inputs)
});
/**
* | output |
* | --- |
* | "Your AI assistant is being prepared" |
*
* @param {Store_Connection_Preparing_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_preparing_heading = /** @type {((inputs?: Store_Connection_Preparing_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_Preparing_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_preparing_heading(inputs)
});
/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Store_Connection_RefreshInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_connection_refresh = /** @type {((inputs?: Store_Connection_RefreshInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Connection_RefreshInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_connection_refresh(inputs)
});
/**
* | output |
* | --- |
* | "Each store has its own admin. Open GoNovus from the Shopify admin of the store you want to manage." |
*
* @param {Store_Entry_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_entry_body = /** @type {((inputs?: Store_Entry_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Entry_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_entry_body(inputs)
});
/**
* | output |
* | --- |
* | "Open GoNovus from Shopify" |
*
* @param {Store_Entry_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const store_entry_heading = /** @type {((inputs?: Store_Entry_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Entry_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.store_entry_heading(inputs)
});